module.exports = __webpack_public_path__ + "static/media/maestro-logo.b44fa76e.svg";